import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { api } from '../../services/api'; // Descomentar cuando tengas los endpoints

// ============================================================================
// ASYNC THUNKS - Operaciones asíncronas (TODO: Implementar con backend)
// ============================================================================

// TODO: Obtener consultas del cliente
export const fetchClientConsultations = createAsyncThunk(
  'clientDashboard/fetchClientConsultations',
  async (_, { getState, rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const response = await api.get(`/client/${auth.user.id}/consultations`);
      // return response.data;

      // PLACEHOLDER - Retornar datos fake por ahora
      return [];
    } catch (error) {
      return rejectWithValue('Error al cargar consultas');
    }
  }
);

// TODO: Obtener citas programadas del cliente
export const fetchClientAppointments = createAsyncThunk(
  'clientDashboard/fetchClientAppointments',
  async (_, { getState, rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const response = await api.get(`/client/${auth.user.id}/appointments`);
      // return response.data;

      // PLACEHOLDER
      return [];
    } catch (error) {
      return rejectWithValue('Error al cargar citas');
    }
  }
);

// TODO: Obtener abogados favoritos
export const fetchFavoriteLawyers = createAsyncThunk(
  'clientDashboard/fetchFavoriteLawyers',
  async (_, { getState, rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const response = await api.get(`/client/${auth.user.id}/favorites`);
      // return response.data;

      // PLACEHOLDER
      return [];
    } catch (error) {
      return rejectWithValue('Error al cargar favoritos');
    }
  }
);

// TODO: Buscar abogados disponibles
export const searchAvailableLawyers = createAsyncThunk(
  'clientDashboard/searchAvailableLawyers',
  async (searchCriteria, { rejectWithValue }) => {
    try {
      // const { specialty, location, priceRange, availability } = searchCriteria;
      // const response = await api.get('/lawyers/search', { params: searchCriteria });
      // return response.data;

      // PLACEHOLDER
      return [];
    } catch (error) {
      return rejectWithValue('Error al buscar abogados');
    }
  }
);

// TODO: Crear nueva consulta express
export const createExpressConsultation = createAsyncThunk(
  'clientDashboard/createExpressConsultation',
  async (consultationData, { getState, rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const response = await api.post('/consultations/express', {
      //   ...consultationData,
      //   clientId: auth.user.id
      // });
      // return response.data;

      // PLACEHOLDER
      return { id: Date.now(), status: 'pending', ...consultationData };
    } catch (error) {
      return rejectWithValue('Error al crear consulta');
    }
  }
);

// TODO: Agendar cita con abogado
export const scheduleAppointment = createAsyncThunk(
  'clientDashboard/scheduleAppointment',
  async (appointmentData, { getState, rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const response = await api.post('/appointments', {
      //   ...appointmentData,
      //   clientId: auth.user.id
      // });
      // return response.data;

      // PLACEHOLDER
      return { id: Date.now(), status: 'pending', ...appointmentData };
    } catch (error) {
      return rejectWithValue('Error al agendar cita');
    }
  }
);

// TODO: Calificar abogado después de consulta/cita
export const rateLawyer = createAsyncThunk(
  'clientDashboard/rateLawyer',
  async ({ lawyerId, rating, comment }, { rejectWithValue }) => {
    try {
      // const response = await api.post(`/lawyers/${lawyerId}/rate`, { rating, comment });
      // return response.data;

      // PLACEHOLDER
      return { lawyerId, rating, comment };
    } catch (error) {
      return rejectWithValue('Error al calificar abogado');
    }
  }
);

// ============================================================================
// INITIAL STATE - Estado inicial del dashboard del cliente
// ============================================================================

const INITIAL_STATE = {
  // Consultas del cliente
  consultations: {
    active: [], // Consultas en curso
    pending: [], // Consultas pendientes de respuesta
    completed: [], // Consultas completadas
    loading: false,
    error: null,
  },

  // Citas programadas
  appointments: {
    upcoming: [], // Próximas citas
    past: [], // Citas pasadas
    loading: false,
    error: null,
  },

  // Búsqueda de abogados
  lawyerSearch: {
    results: [],
    filters: {
      specialty: '',
      location: '',
      priceRange: { min: 0, max: 1000 },
      availability: 'any', // 'any', 'now', 'today', 'week'
      rating: 0,
    },
    loading: false,
    error: null,
  },

  // Abogados favoritos
  favorites: {
    lawyers: [],
    loading: false,
    error: null,
  },

  // Historial y estadísticas del cliente
  clientStats: {
    totalConsultations: 0,
    totalAppointments: 0,
    totalSpent: 0,
    favoriteSpecialties: [],
    loading: false,
    error: null,
  },

  // Estado de la UI del dashboard
  ui: {
    selectedTab: 'overview', // 'overview', 'consultations', 'appointments', 'search', 'favorites'
    showNotifications: false,
    searchView: 'grid', // 'grid', 'list'
    filters: {
      consultationStatus: 'all', // 'all', 'active', 'pending', 'completed'
      appointmentStatus: 'all', // 'all', 'upcoming', 'past'
      dateRange: 'all', // 'all', 'week', 'month', 'year'
    },
    modals: {
      newConsultation: false,
      scheduleAppointment: false,
      lawyerProfile: false,
      rateLawyer: false,
      editProfile: false,
    },
    selectedLawyer: null, // Para mostrar detalles de abogado seleccionado
  },

  // Estado general
  isLoading: false,
  error: null,
  lastUpdated: null,
};

// ============================================================================
// SLICE - Definición del slice
// ============================================================================

const clientDashboardSlice = createSlice({
  name: 'clientDashboard',
  initialState: INITIAL_STATE,
  reducers: {
    // UI Actions - Acciones para manejar la interfaz
    setSelectedTab: (state, action) => {
      state.ui.selectedTab = action.payload;
    },

    toggleNotifications: state => {
      state.ui.showNotifications = !state.ui.showNotifications;
    },

    setSearchView: (state, action) => {
      state.ui.searchView = action.payload;
    },

    setFilter: (state, action) => {
      const { filterType, value } = action.payload;
      state.ui.filters[filterType] = value;
    },

    setSearchFilter: (state, action) => {
      const { filterType, value } = action.payload;
      state.lawyerSearch.filters[filterType] = value;
    },

    clearSearchFilters: state => {
      state.lawyerSearch.filters = INITIAL_STATE.lawyerSearch.filters;
    },

    openModal: (state, action) => {
      const modalName = action.payload;
      state.ui.modals[modalName] = true;
    },

    closeModal: (state, action) => {
      const modalName = action.payload;
      state.ui.modals[modalName] = false;
    },

    closeAllModals: state => {
      Object.keys(state.ui.modals).forEach(modal => {
        state.ui.modals[modal] = false;
      });
    },

    setSelectedLawyer: (state, action) => {
      state.ui.selectedLawyer = action.payload;
    },

    clearSelectedLawyer: state => {
      state.ui.selectedLawyer = null;
    },

    // Data Actions - Acciones para datos locales
    addToFavorites: (state, action) => {
      const lawyer = action.payload;
      const exists = state.favorites.lawyers.find(l => l.id === lawyer.id);
      if (!exists) {
        state.favorites.lawyers.push(lawyer);
      }
    },

    removeFromFavorites: (state, action) => {
      const lawyerId = action.payload;
      state.favorites.lawyers = state.favorites.lawyers.filter(lawyer => lawyer.id !== lawyerId);
    },

    updateLocalConsultation: (state, action) => {
      const { consultationId, updates } = action.payload;

      // Buscar y actualizar en todas las listas
      ['active', 'pending', 'completed'].forEach(listName => {
        const consultation = state.consultations[listName].find(c => c.id === consultationId);
        if (consultation) {
          Object.assign(consultation, updates);
        }
      });
    },

    // Clear Actions - Limpiar datos
    clearDashboardData: state => {
      return INITIAL_STATE;
    },

    clearErrors: state => {
      state.error = null;
      state.consultations.error = null;
      state.appointments.error = null;
      state.lawyerSearch.error = null;
      state.favorites.error = null;
      state.clientStats.error = null;
    },

    clearSearchResults: state => {
      state.lawyerSearch.results = [];
    },
  },

  extraReducers: builder => {
    // Fetch Client Consultations
    builder
      .addCase(fetchClientConsultations.pending, state => {
        state.consultations.loading = true;
        state.consultations.error = null;
      })
      .addCase(fetchClientConsultations.fulfilled, (state, action) => {
        state.consultations.loading = false;
        // TODO: Separar consultas por estado cuando venga del backend
        state.consultations.active = action.payload.filter(c => c.status === 'active');
        state.consultations.pending = action.payload.filter(c => c.status === 'pending');
        state.consultations.completed = action.payload.filter(c => c.status === 'completed');
        state.lastUpdated = new Date().toISOString();
      })
      .addCase(fetchClientConsultations.rejected, (state, action) => {
        state.consultations.loading = false;
        state.consultations.error = action.payload;
      });

    // Fetch Client Appointments
    builder
      .addCase(fetchClientAppointments.pending, state => {
        state.appointments.loading = true;
        state.appointments.error = null;
      })
      .addCase(fetchClientAppointments.fulfilled, (state, action) => {
        state.appointments.loading = false;
        const now = new Date();
        // TODO: Separar citas por fecha cuando venga del backend
        state.appointments.upcoming = action.payload.filter(apt => new Date(apt.date) >= now);
        state.appointments.past = action.payload.filter(apt => new Date(apt.date) < now);
      })
      .addCase(fetchClientAppointments.rejected, (state, action) => {
        state.appointments.loading = false;
        state.appointments.error = action.payload;
      });

    // Fetch Favorite Lawyers
    builder
      .addCase(fetchFavoriteLawyers.pending, state => {
        state.favorites.loading = true;
        state.favorites.error = null;
      })
      .addCase(fetchFavoriteLawyers.fulfilled, (state, action) => {
        state.favorites.loading = false;
        state.favorites.lawyers = action.payload;
      })
      .addCase(fetchFavoriteLawyers.rejected, (state, action) => {
        state.favorites.loading = false;
        state.favorites.error = action.payload;
      });

    // Search Available Lawyers
    builder
      .addCase(searchAvailableLawyers.pending, state => {
        state.lawyerSearch.loading = true;
        state.lawyerSearch.error = null;
      })
      .addCase(searchAvailableLawyers.fulfilled, (state, action) => {
        state.lawyerSearch.loading = false;
        state.lawyerSearch.results = action.payload;
      })
      .addCase(searchAvailableLawyers.rejected, (state, action) => {
        state.lawyerSearch.loading = false;
        state.lawyerSearch.error = action.payload;
      });

    // Create Express Consultation
    builder
      .addCase(createExpressConsultation.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createExpressConsultation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.consultations.pending.push(action.payload);
        // Cerrar modal después de crear
        state.ui.modals.newConsultation = false;
      })
      .addCase(createExpressConsultation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Schedule Appointment
    builder
      .addCase(scheduleAppointment.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(scheduleAppointment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.appointments.upcoming.push(action.payload);
        // Cerrar modal después de agendar
        state.ui.modals.scheduleAppointment = false;
      })
      .addCase(scheduleAppointment.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Rate Lawyer
    builder.addCase(rateLawyer.fulfilled, (state, action) => {
      // TODO: Actualizar rating local si es necesario
      // Cerrar modal de rating
      state.ui.modals.rateLawyer = false;
    });
  },
});

// ============================================================================
// EXPORTS - Acciones y selectores
// ============================================================================

// Export actions
export const {
  setSelectedTab,
  toggleNotifications,
  setSearchView,
  setFilter,
  setSearchFilter,
  clearSearchFilters,
  openModal,
  closeModal,
  closeAllModals,
  setSelectedLawyer,
  clearSelectedLawyer,
  addToFavorites,
  removeFromFavorites,
  updateLocalConsultation,
  clearDashboardData,
  clearErrors,
  clearSearchResults,
} = clientDashboardSlice.actions;

// Selectores específicos para el dashboard del cliente
export const selectClientDashboard = state => state.clientDashboard;
export const selectClientConsultations = state => state.clientDashboard.consultations;
export const selectClientAppointments = state => state.clientDashboard.appointments;
export const selectLawyerSearchResults = state => state.clientDashboard.lawyerSearch.results;
export const selectLawyerSearchFilters = state => state.clientDashboard.lawyerSearch.filters;
export const selectFavoriteLawyers = state => state.clientDashboard.favorites.lawyers;
export const selectSelectedTab = state => state.clientDashboard.ui.selectedTab;
export const selectSelectedLawyer = state => state.clientDashboard.ui.selectedLawyer;
export const selectDashboardLoading = state => state.clientDashboard.isLoading;
export const selectClientStats = state => state.clientDashboard.clientStats;

export default clientDashboardSlice.reducer;
